import React, { useEffect, useState } from 'react'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import { getBoundActions } from '../../../actions/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import AccountCancelOffer from '../AccountCancelOffer/index'
import Support from '../../Support/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { scrollToTop } from '../../../services/dom/index'
import { shouldRenderCancelThreeMonthOffer } from '../../../services/user-account/index'
import AccountCancelThreeMonthOffer from '../AccountCancelThreeMonthOffer/index'

function AccountCancelOfferPage (props) {
  const {
    auth,
    userAccount,
  } = props
  const accountCancelReason = userAccount.getIn(['manageSubscription', 'data', 'cancelReason'])

  // Freeze eligibility state on mount to prevent UI changes while user is interacting
  const [threeMonthOfferEligible] = useState(() => shouldRenderCancelThreeMonthOffer(props))

  // If the user is eligible for the three month offer, show the three month offer page
  if (threeMonthOfferEligible) {
    return (
      <AccountCancelThreeMonthOffer />
    )
  }

  if (!getAuthIsLoggedIn(auth) || !accountCancelReason) {
    return null
  }

  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <div className="account-cancel-offer-page">
      <div className="account-cancel-offer-page__content">
        <AccountCancelOffer fullPage />
      </div>
      <Support />
    </div>
  )
}

AccountCancelOfferPage.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  subscription: ImmutablePropTypes.map.isRequired,
  setUserAccountCancel: PropTypes.func.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      userAccount: state.userAccount,
      subscription: state.subscription,
      staticText: state.staticText.getIn(['data', 'accountCancelOfferPage']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUserAccountCancel: actions.userAccount.setUserAccountCancel,
      }
    },
  ),
)(AccountCancelOfferPage)
